export const salesDashboardStats = {
  newLeads: 12,
  currentOpportunities: 5,
  closedCustomers: 3,
  newBookings: 2,
}; 